import React, { ReactNode } from 'react';
import { Grid, GridItem } from '../../helpers';
import {
  Accordion,
  AccordionItem,
  AccordionItemTrigger,
  AccordionItemContent,
} from '../../components/Accordion';
import { ModuleHeader } from '../../primitives';
import { LayoutProp } from '~/core/styles/theme/layout';

const CallToAction = (callToActionProps: CallToActionProps) => {
  if (!callToActionProps) return null;
  const {
    title,
    lead,
    items,
    counterBackground,
    isOrdered,
    gridItemSize,
    gridItemPush,
  } = callToActionProps;

  return (
    <>
      <div className="m-calltoaction">
        <Grid columns={{ zero: 12 }}>
          <GridItem
            size={gridItemSize || { zero: 12, ultra: 8 }}
            push={gridItemPush || { zero: 0, ultra: 2 }}
          >
            <ModuleHeader title={title || ''} lead={lead || undefined} />
            <Accordion allowMultipleExpanded allowItemCollapse>
              {items.map(
                (
                  action: {
                    title: string;
                    richtext: ReactNode;
                    iconSrc?: string;
                  },
                  rowIndex: number,
                ) => {
                  return (
                    <AccordionItem key={rowIndex}>
                      <AccordionItemTrigger
                        counter={
                          isOrdered === undefined || isOrdered
                            ? rowIndex + 1
                            : undefined
                        }
                        counterBackground={counterBackground}
                        src={action.iconSrc}
                      >
                        {action.title}
                      </AccordionItemTrigger>
                      <AccordionItemContent>
                        {action.richtext}
                      </AccordionItemContent>
                    </AccordionItem>
                  );
                },
              )}
            </Accordion>
          </GridItem>
        </Grid>
      </div>
    </>
  );
};

export type CallToActionProps = {
  items: {
    title: string;
    richtext: ReactNode;
    iconSrc?: string;
  }[];
  title?: string;
  lead?: string;
  counterBackground?: string;
  isOrdered?: boolean;
  gridItemSize?: { [key: LayoutProp['name']]: number };
  gridItemPush?: { [key: LayoutProp['name']]: number };
} | null;

export default CallToAction;
